import { filesApi } from './api'

function extractS3KeyFromUrl(url) {
  if (!url || !url.includes('amazonaws.com/')) return null
  try {
    return decodeURIComponent(new URL(url).pathname.slice(1))
  } catch {
    return null
  }
}

/**
 * Resolve a file reference for download (handles legacy entries missing S3 key).
 */
export function resolveFileRef(file, churchCode) {
  if (!file) return null
  if (file.key || file.url) return file
  if (file.filename && churchCode) {
    return {
      ...file,
      key: `uploaded-files/${churchCode}/${file.filename}`
    }
  }
  return file
}

/**
 * Open a file download using a short-lived presigned S3 URL.
 */
export async function openFileDownload(file, churchCode = null) {
  const resolved = resolveFileRef(file, churchCode) || file
  const key = resolved?.key || extractS3KeyFromUrl(resolved?.url)
  if (!key) {
    if (resolved?.url) {
      window.open(resolved.url, '_blank', 'noopener,noreferrer')
      return
    }
    throw new Error('MISSING_KEY')
  }

  const { data } = await filesApi.getDownloadUrl(key)
  if (data?.success === false || !data?.data?.downloadUrl) {
    const err = new Error(data?.message || 'DOWNLOAD_UNAVAILABLE')
    err.code = 'NOT_FOUND'
    throw err
  }
  window.open(data.data.downloadUrl, '_blank', 'noopener,noreferrer')
}
